<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
      <v-card-title primary-title class="text-subtittle">
        Constancias Generadas
      </v-card-title>
      <v-card-text>
        <v-row justify="end">
          <v-col cols="6" md="4" lg="4">
            <v-text-field
              label="Buscar"
              v-model="search"
              outlined
              hide-details
              rounded
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <!-- Tabla de constancias -->
            <v-data-table
              :headers="constanciasHeaders"
              :items="constancias"
              :items-per-page="5"
              class="elevation-1"
              :loading="loadingConstancias"
              loading-text="Cargando constancias..."
              no-data-text="No hay constancias generadas"
              :search="search"
            >
              <template v-slot:item.archivo="{ item }">
                <v-tooltip bottom v-if="item.archivo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="verArchivo(item.archivo)"
                    >
                      <v-icon small>mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver archivo</span>
                </v-tooltip>
                <span v-else>-</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2'



export default {

  name: 'App',
  components: {

  },
  data() {
    return {
      buffer: "",    // guarda los caracteres del lector
      ultimoQR: null, // guardamos el último QR completo
      archivo: '',
      search: '',

      loadingConstancias: false,
      constancias: [], // aquí llenas tus datos desde la API
      constanciasHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Usuario', value: 'id_usuario' },
        { text: 'Sucursal', value: 'sucursal' },
        { text: 'Ciclo', value: 'ciclo' },
        { text: 'Archivo', value: 'archivo', sortable: false, align: 'center' }
      ]
    };
  },

  async created () {
      await this.inicializar()
    },

  methods: {

    procesarQR(valor) {
        // const valor = event.target.value.trim();

        if (valor) {

          this.archivo = ''

          console.log('Código leído:', valor);

          this.$http.get(`alumnos.obtener.constancia.estudios?id=${ valor }`).then(response=>{

            console.log( response )
            this.archivo = `https://lmsinbi.club/api-movil/ver-constancias-estudios/${ response.data.archivo }`
            this.cargar = false

          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })


        }
    },

    inicializar() {

      this.$http.get(`alumnos.obtener.constancias.estudios`).then(response=>{

        console.log( response )
        this.constancias = response.data
        //this.archivo = `https://lmsinbi.club/api-movil/ver-constancias-estudios/${ response.data.archivo }`
        this.cargar = false

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })

    },

    verArchivo(archivo) {
      // Ejemplo: abrir el archivo PDF en nueva pestaña
      window.open('https://lmsinbi.club/api-movil/ver-constancias-estudios/' + archivo, '_blank')
    },


  },
}
</script>

